// extracted by mini-css-extract-plugin
module.exports = {"panel":"DTICalculator_panel__AMG9C","dti":"DTICalculator_dti__tcrOF","cta":"DTICalculator_cta__xVRfZ"};